export default __webpack_public_path__ + "static/media/games-hover.4aecd899.webp";